import React from 'react'
import PropTypes from 'prop-types'
import { useVendors } from 'api/hooks/use-vendors'
import RecordFilterPopover from './RecordFilterPopover'

const vendorLabel = (vendor) => (vendor.external_id ? `${vendor.name} (${vendor.external_id})` : vendor.name)

// Vendors as one filter in the AND/OR group builder, searched as the View's vendor picker searches.
const VendorFilterPopover = ({ column, ...props }) => {
  const useResults = (search) => {
    const { data, isFetching } = useVendors({
      params: { search, section: column.section_id, page: 1, perPage: 20 },
      options: { enabled: search.length >= 2 }
    })
    return { results: (data?.data || []).map((vendor) => ({ id: vendor.id, label: vendorLabel(vendor) })), isFetching }
  }

  return <RecordFilterPopover title={column.display_name || column.name} noun="vendor" useResults={useResults} {...props} />
}

VendorFilterPopover.propTypes = { column: PropTypes.object.isRequired }

export default VendorFilterPopover
